<template>
  <div class="countdown">
    <span class="countdown__body">
      <span>{{ days ? days + ':' : '' }}{{ hours }}:{{ minutes }}:{{ seconds }}</span>
    </span>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

export default {
  name: 'HecUtilCountdown',
  props: ['datetime', 'format'],
  data() {
    return {
      now: Math.trunc(new Date().getTime() / 1000),
      timer: false
    }
  },
  computed: {
    countdown() {
      let countdown = {}
      console.log(this.datetime)
      countdown.date = dayjs(this.datetime, 'DD-MM-YYYY HH:mm:ss').unix()
      console.log(countdown.date)
      return countdown
    },
    seconds() {
      return ('0' + ((this.countdown.date - this.now) % 60)).slice(-2)
    },
    minutes() {
      return ('0' + (Math.trunc((this.countdown.date - this.now) / 60) % 60)).slice(-2)
    },
    hours() {
      return ('0' + (Math.trunc((this.countdown.date - this.now) / 60 / 60) % 24)).slice(-2)
    },
    days() {
      return ('0' + Math.trunc((this.countdown.date - this.now) / 60 / 60 / 24)).slice(-2)
    }
  },
  created() {
    this.timer = setInterval(() => {
      if (this.seconds === '00' && this.minutes === '00' && this.hours === '00' && this.days === '00') {
        this.$emit('end')
      } else {
        this.now = Math.trunc(new Date().getTime() / 1000)
      }
    }, 1000)
  },
  destroyed() {
    clearInterval(this.timer)
  }
}
</script>

<style scoped></style>
